import type { Plugin, SegmentEvent } from '@segment/analytics-next'
import { addMinutes } from 'date-fns'
import { v4 as uuidv4 } from 'uuid'

export const SESSION_ID = 'SESSION_ID'
export const LIMIT_SESSION_ID_TIME = 'LIMIT_SESSION_ID_TIME'

export const setSessionTimestamp = (value: string) => {
  sessionStorage.setItem(LIMIT_SESSION_ID_TIME, value)
}

export const getLimitSessionTime = () => {
  const limitSessionTimestamp = sessionStorage.getItem(LIMIT_SESSION_ID_TIME)
  const sessionTimestampValue = limitSessionTimestamp || new Date()
  const timeMinutesSessionId = 30
  return addMinutes(sessionTimestampValue, timeMinutesSessionId)
}

export const generateSessionId = (): string => {
  const sessionId = uuidv4()
  sessionStorage.setItem(SESSION_ID, sessionId)

  return sessionId
}

export const getSessionId = (): string => {
  const sessionId = sessionStorage.getItem(SESSION_ID)

  if (sessionId) {
    return sessionId
  }

  return generateSessionId()
}

export const insertSessionIdProperties = (
  event: SegmentEvent
): SegmentEvent => {
  const currentDate = new Date()
  const limitTimeSession = getLimitSessionTime()
  const sessionExpirated = currentDate > limitTimeSession

  setSessionTimestamp(currentDate.toString())

  if (sessionExpirated) {
    generateSessionId()
  }

  event.properties ??= {}
  event.properties.session_id = getSessionId()

  return event
}

export const sessionIdPlugin: Plugin = {
  name: 'Session ID Interceptor',
  type: 'before',
  version: '1.0.0',
  isLoaded: () => true,
  load: () => Promise.resolve(),
  track: ctx => {
    const { event } = ctx
    ctx.event = insertSessionIdProperties(event)
    return ctx
  },
}
